<template>
  <span>
    <template
      v-for="(part, index) in parts"
      :key="index"
    >
      <span
        v-if="index"
        :class="$style.delimiter"
      >•</span>{{ part }}
    </template>
  </span>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EllipseText',
  props: {
    parts: {
      type: Array,
      required: true
    }
  }
});
</script>

<style module>
.delimiter {
  margin: 0 var(--Space-200, 8px);
  opacity: 0.3;
}
</style>

<i18n lang="json">{}</i18n>
